import firebase from "../utils/firebaseConfig"

// const initialState = [
//   {
//     name: "Programming Artificial Intelligence",
//     description: "The student will learn how to make comprehensive applications utilising Artificial Intelligence, the student can choose from many languages including C, C++, Java and React for the front-end and between Python and R for the Artificial Intelligence.",
//     data: [
//       {
//         name: "Programming",
//         value: 15933,
//         // uid: uuid(),
//         index: 0,
//         children: [
//           {
//             masterIndex: 0,
//             parentIndex: 0,
//             index: 0,
//             name: "Data",
//             value: 903,
//             strength: 7,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 0,
//                 parentIndex: 0,
//                 index: 0,
//                 name: "Parse", 
//                 value: 100, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 0,
//                 index: 1,
//                 name: "Visualise", 
//                 value: 60, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//             ]
//           },
//           {
//             masterIndex: 0,
//             parentIndex: 0,
//             index: 1,
//             name: "Computer",
//             value: 4702,
//             strength: 8,
//             // uid: uuid(),
//             children: [
//               {
//                 masterIndex: 0,
//                 parentIndex: 1,
//                 index: 0,
//                 name: "Apple", 
//                 value: 198, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 1,
//                 index: 1,
//                 name: "Windows", 
//                 value: 148, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 1,
//                 index: 2,
//                 name: "RAM", 
//                 value: 178, 
//                 strength: 12,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 1,
//                 index: 3,
//                 name: "CPU", 
//                 value: 26, 
//                 strength: 8,
//                 // uid: uuid(),
//               }
//             ]
//           },
//           {
//             masterIndex: 0,
//             parentIndex: 0,
//             index: 2,
//             name: "Applications",
//             value: 3455,
//             strength: 11,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 0,
//                 parentIndex: 2,
//                 index: 0,
//                 name: "Web", 
//                 value: 415, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 2,
//                 index: 1,
//                 name: "Mobile", 
//                 value: 148, 
//                 strength: 8,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 0,
//                 parentIndex: 2,
//                 index: 2,
//                 name: "IoT", 
//                 value: 89, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//             ]
//           },
//           {
//             masterIndex: 0,
//             parentIndex: 0,
//             index: 3,
//             name: "Languages",
//             value: 1999,
//             strength: 5,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 0,
//                 parentIndex: 3,
//                 index: 0,
//                 name: "Python", 
//                 value: 80, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               {
//                 masterIndex: 0,
//                 parentIndex: 3,
//                 index: 1,
//                 name: "C++",
//                 value: 148,
//                 strength: 12,
//                 // uid: uuid(),
//               },
//             ]
//           }
    
//         ]
//       },
//       {
//         name: "Artificial Intelligence",
//         value: 15933,
//         // uid: uuid(),
//         index: 1,
//         children: [
//           {
//             masterIndex: 1,
//             parentIndex: 1,
//             index: 0,
//             name: "Linear Regression",
//             value: 903,
//             strength: 7,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 1,
//                 parentIndex: 0,
//                 index: 0,
//                 name: "Graph", 
//                 value: 100, 
//                 strength: 2, 
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 0,
//                 index: 1,
//                 name: "Forecasting", 
//                 value: 60, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//             ]
//           },
//           {
//             masterIndex: 1,
//             parentIndex: 1,
//             index: 1,
//             name: "Neural Networks",
//             value: 5200,
//             strength: 6,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 1,
//                 parentIndex: 1,
//                 index: 0,
//                 name: "Simple", 
//                 value: 13, 
//                 strength: 5,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 1,
//                 index: 1,
//                 name: "Deep", 
//                 value: 98, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
//             ]
//           },
//           {
//             masterIndex: 1,
//             parentIndex: 1,
//             index: 2,
//             name: "Deep Learning",
//             value: 4702,
//             strength: 8,
//             // uid: uuid(),
//             children: [
//               {
//                 masterIndex: 1,
//                 parentIndex: 2,
//                 index: 0,
//                 name: "Processes", 
//                 value: 198, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 2,
//                 index: 1,
//                 name: "Data Science", 
//                 value: 148, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 2,
//                 index: 2,
//                 name: "Extraction", 
//                 value: 178, 
//                 strength: 12,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 2,
//                 index: 3,
//                 name: "Classification", 
//                 value: 26, 
//                 strength: 8,
//                 // uid: uuid(),
//               }
//             ]
//           },
//           {
//             masterIndex: 1,
//             parentIndex: 1,
//             index: 3,
//             name: "Machine Learning",
//             value: 3455,
//             strength: 11,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 1,
//                 parentIndex: 3,
//                 index: 0,
//                 name: "Computer", 
//                 value: 148, 
//                 strength: 8,
//                 // uid: uuid(),
//               },
//               { 
//                 masterIndex: 1,
//                 parentIndex: 3,
//                 index: 1,
//                 name: "Science", 
//                 value: 89, 
//                 strength: 2,
//                 // uid: uuid(),
//               },
  
//             ]
//           },
//           {
//             masterIndex: 1,
//             parentIndex: 1,
//             index: 4,
//             name: "Data",
//             value: 1999,
//             strength: 5,
//             // uid: uuid(),
//             children: [
//               { 
//                 masterIndex: 1,
//                 parentIndex: 4,
//                 index: 0,
//                 name: "Parsing", 
//                 value: 80, 
//                 strength: 1,
//                 // uid: uuid(),
//               },
//               {
//                 masterIndex: 1,
//                 parentIndex: 4,
//                 index: 1,
//                 name: "Mapping",
//                 value: 148,
//                 strength: 12,
//                 // uid: uuid(),
//               },
//             ]
//           }
    
//         ]
//       },
//     ]
//   }
// ];

const db = firebase.firestore();

db.settings({ 
  ignoreUndefinedProperties: true,
  timestampsInSnapshots: true,
  merge: true });

const userRef = db.collection("nanoCompetencies")

const nanoCompDataReducer = (state = [], action) => {
    switch(action.type) {
        case "ADD_ITEM":
            console.log(action.payload)
            userRef.doc("" + action.payload[0].index + "").set(action.payload[0]);
            //   ,{
            // // userRef.doc("" + action.payload.index + "").set(action.payload,{
            //   timestampsInSnapshots: true,
            //   merge: true
            // }); 
          return state.concat(action.payload)
          // return [...state, action.payload] 


// DE:LETE
   //   userRef.doc("5").delete().then(() => {
          //     console.log("Document successfully deleted!");
          // }).catch((error) => {
          //     console.error("Error removing document: ", error);
          // });



          case "EDIT_ITEM":
            // console.log(action.payload.index)
            // console.log(action.payload)
            console.log("edit items")
            // var index = action.payload.index
            // userRef.doc("" + action.payload.index + "").delete()
            // userRef.doc("" + action.payload.index + "").set(action.payload,{

            userRef.doc("" + action.payload.index + "").set(action.payload).then(() => {
              console.log("Document successfully written!");
          }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(errorCode);
            console.log(errorMessage);
          });
            
            //   ,{
            // //   
            //   ignoreUndefinedProperties: true,
            //   // timestampsInSnapshots: true,
            //   merge: true
            // }); 
            // userRef.doc("" + action.payload.index + "").set(data(action.payload),{
            //   timestampsInSnapshots: true,
            //   merge: true
            // }); 
          return [...state, action.payload]  
           
          case "DELETE_ITEM":
          userRef.doc("" + action.payload.index + "").delete().then(() => {
                console.log("Document successfully deleted!");
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });
          
          
          
          
          
          
          
          case "FETCH_DATA":
        const data = [];

       userRef.onSnapshot((querySnapShot) => {
        querySnapShot.forEach((doc) => {
          data.push(doc.data());
        });
        // console.log(data)

        });
        return data

              // userRef.get()
      // setData(fetchedData)
    
    // getdata()

        
// useEffect(() => {
//   async function getdata() {
//     const ref = firebase
//         .firestore()
//         .collection("nanoCompetencies");
//       const snapshot = await ref.get();
//       const fetchedData = []
//       snapshot.forEach(doc => {
//         fetchedData.push(doc.data());
//         console.log(doc.data());
//         // console.log(data)
//       });
//     fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)

//       setData(fetchedData)
//     }
//     console.log(data)
//     getdata()
//     console.log(data)

// },[localStore])

        default: 
          return state;

      }
}

export default nanoCompDataReducer;